import { JobStatus } from '../JobStatus';
var JobStatusDto = /** @class */ (function () {
    function JobStatusDto(job, _a) {
        var sessionStatus = _a.sessionStatus, previewUrl = _a.previewUrl, thumbUrl = _a.thumbUrl, progress = _a.progress, reason = _a.reason, resultVideoId = _a.resultVideoId, audio = _a.audio, font = _a.font, themeId = _a.themeId, sources = _a.sources, fileName = _a.fileName, syndicationCallbackUrl = _a.syndicationCallbackUrl, streamUrl = _a.streamUrl, downloadUrl = _a.downloadUrl, orientation = _a.orientation, primaryColor = _a.primaryColor, secondaryColor = _a.secondaryColor;
        this.progress = 0;
        this.job = job;
        if (!sessionStatus || !Object.values(JobStatus).includes(sessionStatus)) {
            throw new Error("Job status '".concat(sessionStatus, "' is unknown"));
        }
        switch (sessionStatus) {
            case JobStatus.DONE:
            case JobStatus.ERROR:
                this.progress = 1;
                break;
            case JobStatus.INIT:
                this.progress = 0;
                break;
            case JobStatus.PROCESSING:
                this.progress = progress || 0;
                break;
            default:
                throw new Error("Invalid sessionStatus ".concat(sessionStatus, " for progress"));
        }
        this.status = sessionStatus;
        this.previewUrl = previewUrl;
        this.thumbUrl = thumbUrl;
        this.reason = reason;
        this.resultVideoId = resultVideoId;
        this.audio = audio;
        this.font = font;
        this.themeId = themeId;
        this.sources = sources;
        this.fileName = fileName || undefined;
        this.syndicationCallbackUrl = syndicationCallbackUrl;
        this.streamUrl = streamUrl;
        this.downloadUrl = downloadUrl;
        this.orientation = orientation;
        this.primaryColor = primaryColor;
        this.secondaryColor = secondaryColor;
    }
    return JobStatusDto;
}());
export { JobStatusDto };
//# sourceMappingURL=JobStatusDto.js.map